import { createAsyncThunk } from '@reduxjs/toolkit';
import userApi from '~/apis/user';
import { IEditUser, IParamsGetUser, IResponseGetUser, IResponseGetUserDetail } from '~/utils/interface/user';

export const handleGetUserList = createAsyncThunk<IResponseGetUser, IParamsGetUser>(
  'GET_USER_LIST',
  async (params: IParamsGetUser = {}, { rejectWithValue }) => {
    try {
      const res = await userApi.getList(params);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleCreateUser = createAsyncThunk<IResponseGetUserDetail, IEditUser>(
  'CREATE_USER',
  async (data: IEditUser, { rejectWithValue }) => {
    try {
      const res = await userApi.create(data);
      return res.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);
